import React from 'react';
import PropTypes from "prop-types";

import {DateFormatter} from "../../services/date";
import KeyValueHorizontal from "../../components/KeyValueHorizontal";

import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import KeyValueStacked from "../../components/KeyValueStacked";

const OfferDetails = props => {
    const {
        titleIt,
        titleEn,
        descriptionIt,
        descriptionEn,
        startDate,
        endDate,
        price,
        minPeople,
        minNight,
        petsAllowed,
        pictureUrl,
        homeName,
        apartmentName
    } = props;

    const minPrice = price * minPeople * minNight;

    return (
        <React.Fragment>
            <Grid container spacing={2}>

                <Grid item xs={12} md={5}>
                    {
                        pictureUrl ? (
                            <img alt={`${homeName}-${apartmentName}`}
                                 src={pictureUrl}
                                 style={{width: "100%", height: "100%", objectFit: "cover"}}/>
                        ) : (
                            <Skeleton variant="rectangular" width="100%" height="100%"/>
                        )
                    }
                </Grid>

                <Grid item xs={12} md={7}>
                    <Typography variant="h5" align="center">
                        {DateFormatter.longString(startDate)} - {DateFormatter.longString(endDate)}
                    </Typography>

                    <Box sx={{py: 8}}>
                        <KeyValueHorizontal valueTextVariant="h5"
                                            stakingBreakpoint="md"
                                            spacing={2}
                                            pairs={[
                                                ["Prezzo a notte per persona", `${price} €`],
                                                ["Prezzo minimo", `${minPrice} €`]
                                            ]}/>
                    </Box>

                    <KeyValueHorizontal horizontalDivider={true}
                                        pairs={[
                                            ["Min. persone", minPeople],
                                            ["Min. notti", minNight],
                                            ["Animali", petsAllowed ? "Si" : "No"]
                                        ]}/>
                </Grid>

                <Grid item xs={12}>
                    <KeyValueStacked spacing={1}
                                     pairs={[
                                         ["Titolo in italiano", titleIt],
                                         ["Descrizione in italiano", descriptionIt],
                                     ]}/>

                    <Box sx={{py: 2}}>
                        <Divider/>
                    </Box>

                    <KeyValueStacked spacing={1}
                                     pairs={[
                                         ["Titolo in inglese", titleEn],
                                         [" Descrizione in inglese", descriptionEn],
                                     ]}/>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};

OfferDetails.propTypes = {
    titleIt: PropTypes.string.isRequired,
    titleEn: PropTypes.string.isRequired,
    descriptionIt: PropTypes.string.isRequired,
    descriptionEn: PropTypes.string.isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    price: PropTypes.number.isRequired,
    minPeople: PropTypes.number.isRequired,
    minNight: PropTypes.number.isRequired,
    petsAllowed: PropTypes.bool.isRequired,
    pictureUrl: PropTypes.string.isRequired,
    homeName: PropTypes.string.isRequired,
    apartmentName: PropTypes.string.isRequired,
};

export default OfferDetails;